"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faPlus = void 0;
var faPlus = {
  prefix: 'fal',
  iconName: 'faPlus',
  icon: [448, 512, [], '', 'M432 256C432 264.8 424.8 272 416 272h-176V448c0 8.844-7.156 16.01-16 16.01S208 456.8 208 448V272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h176V64c0-8.844 7.156-15.99 16-15.99S240 55.16 240 64v176H416C424.8 240 432 247.2 432 256z']
};
exports.faPlus = faPlus;